// extracted by mini-css-extract-plugin
export default {"workflowInstances":"workflowInstances-JJqOQ","workflowsInstanceTable":"workflowsInstanceTable-pz5tt","tabs":"tabs-p_bO6","tabPanel":"tabPanel-oHOCa"};